module.exports = "<div *ngIf=\"status\" id=\"preloader\">\r\n    <div id=\"loader\"></div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/dashboards/loader-service/loader-service.component.html
// module id = ../../../../../src/app/views/dashboards/loader-service/loader-service.component.html
// module chunks = main